module.exports = __webpack_public_path__ + "static/img/materialsax02.a9a0af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsax02.png
// module id = y5yY
// module chunks = 2